module.exports = __webpack_public_path__ + "static/PinterestDesignSystem-60eed2d390cf3a77fe2558681833d2e2.png";